"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderStatus = exports.getAPIUrl = void 0;
const getAPIUrl = () => {
    const backendEnv = process.env.BACKEND_ENV || process.env.NODE_ENV;
    if (process.env.NODE_ENV === "production") {
        return "https://api.ahticlimate.com/v1/";
    }
    if (backendEnv === "local") {
        return "http://localhost:8081/v1/";
    }
    return "https://api-dev.ahticlimate.com/v1/";
};
exports.getAPIUrl = getAPIUrl;
var LoaderStatus;
(function (LoaderStatus) {
    LoaderStatus["Idle"] = "Idle";
    LoaderStatus["Loading"] = "Loading";
    LoaderStatus["Success"] = "Success";
    LoaderStatus["Error"] = "Error";
})(LoaderStatus = exports.LoaderStatus || (exports.LoaderStatus = {}));
